export default __webpack_public_path__ + "static/media/IMG_8911 copie.ebdff0a8.jpg";